import axios from 'axios';
import {
  CREATE_ADDITIONAL_PARTICIPANT_ENDPOINT,
  SELECT_ADDITIONAL_PARTICIPANT_ENDPOINT,
  REMOVE_ADDITIONAL_PARTICIPANT_ENDPOINT,
  GET_AVAILABLE_ADDITIONAL_PARTICIPANTS_ENDPOINT,
} from '../consts';

export const createAdditionalParticipant = ({
  firstName,
  lastName,
  email,
  csrfToken,
  auctionId,
  type,
  onResponse = () => {},
  onError = () => {},
}) => {
  const payload = {
    first_name: firstName,
    last_name: lastName,
    email,
    link_type: type,
    auction_id: auctionId,
  };
  axios
    .post(CREATE_ADDITIONAL_PARTICIPANT_ENDPOINT, payload, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
    })
    .then(onResponse)
    .catch(onError);
};

export const selectAdditionalParticipant = ({
  id,
  csrfToken,
  auctionId,
  type,
  onResponse = () => {},
  onError = () => {},
}) => {
  const payload = {
    id,
    link_type: type,
    auction_id: auctionId,
  };

  axios
    .post(SELECT_ADDITIONAL_PARTICIPANT_ENDPOINT, payload, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
    })
    .then(onResponse)
    .catch(onError);
};

export const removeAdditionalParticipant = ({
  id,
  csrfToken,
  auctionId,
  type,
  onResponse = () => {},
  onError = () => {},
}) => {
  const payload = {
    id,
    link_type: type,
    auction_id: auctionId,
  };

  axios
    .post(REMOVE_ADDITIONAL_PARTICIPANT_ENDPOINT, payload, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
    })
    .then(onResponse)
    .catch(onError);
};

export const getAvailableAdditionalParticipants = ({
  csrfToken,
  auctionInCartId,
  onResponse = () => {},
  onError = () => {},
}) => {
  axios
    .get(
      `${GET_AVAILABLE_ADDITIONAL_PARTICIPANTS_ENDPOINT}/${auctionInCartId}`,
      {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
      }
    )
    .then(onResponse)
    .catch(onError);
};
